/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const fieldValueMappingSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  instanceFieldMappingId: z.int(),
  loopValue: z.string(),
  loopValueId: z.string().nullish(),
  organizationId: z.string(),
  sourceValue: z.string(),
  sourceValueId: z.string().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
